angular.module('cvsApp').service('authenticateUserSAMLService', ['networkService', 'xdrService', 'configManager', 'authenticateUserSAMLModel', 'cvsAppData', function(NS, XS, CM, AUSM, CAD) {

    function authenticateUserSAMLService() {
        this.authenticateUserSAML = function(callBackSuccess, samlReqObj) {
            //get url
            var url = CM.getAGPAPIUrl('AUTHENTICATION_USER_SAML');
            if (url === "URL_ERROR") {

            } else {

                //var url = cvsUtility.updateQueryParam(url, 'appName', 'Portal');
                var request = {
                    url: url,
                    header: {
                        'Content-Type': 'application/xml',
                        'accept': 'application/xml'
                    },
                    data: requestBody(samlReqObj),
                    onSuccess: callBackSuccess
                }
                if (cvsUtility.getIEVersion() <= 9) {
                    XS.makeRequest(url, "", xdrSuccess);

                    function xdrSuccess(data) {
                        AUSM.setResponse(data);
                        callBackSuccess(ESSM.getResponse());
                    }
                } else {
                    var promise = NS.post(request);
                    promise.then(function(data, c, d) {

                        AUSM.setResponse(data.data);
                        callBackSuccess(AUSM.getResponse());
                        //send message to parent
                        // if (!CAD.isGuestRefill()) {
                            //cvsUtility.sendPostMessage("SESSION-ALIVE", "getSaml");
                        // }
                    }, function(reason) {
                        callBackSuccess(NS.httpError(reason));
                    });
                }
            }

        }

        var requestBody = function(samlReqObj) {
            var tokenType = CAD.getTokenType();
            var apikey = CAD.getApiKey();
            var reqObj = {
                "authenticateUserRequest": {
                    "header": {
                        "serviceContext": {
                            "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
                            "lineOfBusiness": "Specialty",
                            "channelName": cvsUtility.queryMap.channel,
                            "tokenID":'',
                            "tokenType": 'SPLLOG',
                            "responseFormat": "XML"
                        },
                        "securityContext": {
                            "apiKey": apikey,
                            "securityType": "apiKey"
                        }
                    },
                    "details": {
                        "SAMLRequest": 'S@37R3qU35T',
                        "SigAlg": 'S!9@7G',
                        "Signature": 'S!9N@7UR3'
                    }
                }
            };
            var x2js = new X2JS();
            var xmlReq = x2js.json2xml_str(reqObj);
            return xmlReq.replace('S@37R3qU35T', samlReqObj.SAMLRequest)
                .replace('S!9@7G', samlReqObj.SigAlg)
                .replace('S!9N@7UR3', samlReqObj.Signature);

        }

    }

    return new authenticateUserSAMLService();
}]);
